import { AxiosError } from 'axios'

export const QUERY_KEYS = {
  AUTH0_LOGIN: 'auth0-login',
  ACCOUNT_DATA: 'account-data',
  USER_INFO: 'user-info',
  TICKET: 'ticket',
  MESSAGES: 'messages',
  APPROVAL: 'approval',
  SLACK_USER_INFO: 'slack-user-info',
  NOTIFICATION_PREFERENCES: 'notification-preferences',
  POLICIES: 'policies',
}

export const MUTATION_KEYS = {
  // Ticket mutations
  CREATE_TICKET: 'createTicket',
  SUBMIT_TICKET: 'submitTicket',
  SAVE_TICKET_DRAFT: 'saveTicketDraft',
  DELETE_TICKET: 'deleteTicket',
  DUPLICATE_TICKET: 'duplicateTicket',

  // Message mutations
  CREATE_MESSAGE: 'createMessage',

  // File mutations
  UPLOAD_FILE: 'uploadFile',
  DELETE_FILE: 'deleteFile',
  GET_FILE_LINK: 'getFileLink',

  // Approval mutations
  REVOKE_APPROVAL: 'revokeApproval',

  // Confirmation mutations
  APPROVE_CONFIRMATION: 'approveConfirmation',
  RESET_CONFIRMATIONS: 'resetConfirmations',

  // Search mutations
  SEARCH_ENTITY: 'searchEntity',

  // Support mutations
  SUBMIT_SUPPORT: 'submitSupport',

  // Slack mutations
  SLACK_CONNECT_USER: 'slackConnectUser',
  SLACK_DISCONNECT_USER: 'slackDisconnectUser',
  SLACK_SEND_TEST_MESSAGE: 'slackSendTestMessage',

  // Settings
  UPDATE_SETTINGS: 'updateSettings',

  // Notification preferences
  UPDATE_NOTIFICATION_PREFERENCES: 'updateNotificationPreferences',

  // Additional emails
  ADD_ADDITIONAL_EMAIL: 'addAdditionalEmail',
  VERIFY_ADDITIONAL_EMAIL: 'verifyAdditionalEmail',
  REMOVE_ADDITIONAL_EMAIL: 'removeAdditionalEmail',
}

export const CACHE_TIMES = {
  xs: 1000 * 60 * 2,
  sm: 1000 * 60 * 5,
  md: 1000 * 60 * 10,
  lg: 1000 * 60 * 20,
  xl: 1000 * 60 * 30,
  endless: Infinity,
}

export const STALE_TIMES = {
  xs: 1000 * 10,
  sm: 1000 * 30,
  md: 1000 * 60 * 2,
  lg: 1000 * 60 * 5,
  xl: 1000 * 60 * 10,
  endless: Infinity,
}

// Max retries per axios error code when a query got no response.
// Unlisted codes and every server response (4xx/5xx) are never retried.
export const QUERY_RETRIES_BY_ERROR_CODE = {
  [AxiosError.ERR_NETWORK]: 3,
  [AxiosError.ECONNABORTED]: 1,
  [AxiosError.ETIMEDOUT]: 1,
}
